/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * train-with-me
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  MicrosoftAspNetCoreMvcProblemDetails,
  TrainWithMeModulesBookingDtosRequestsPatchBookingPolicyRequest,
  TrainWithMeModulesBookingDtosRequestsPutCustomerSelfBookingRequest,
  TrainWithMeModulesBookingDtosResponsesBookingPolicyResponse,
  TrainWithMeModulesBookingDtosResponsesSelfBookingPermissionResponse
} from '../../model';

import { customInstance } from '../../../mutator';
import type { ErrorType , BodyType } from '../../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getBookingPolicy = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesBookingDtosResponsesBookingPolicyResponse>(
      {url: `/booking-policy`, method: 'GET', signal
    },
      options);
    }




export const getGetBookingPolicyQueryKey = () => {
    return [
    `/booking-policy`
    ] as const;
    }


export const getGetBookingPolicyQueryOptions = <TData = Awaited<ReturnType<typeof getBookingPolicy>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookingPolicy>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBookingPolicyQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBookingPolicy>>> = ({ signal }) => getBookingPolicy(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBookingPolicy>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBookingPolicyQueryResult = NonNullable<Awaited<ReturnType<typeof getBookingPolicy>>>
export type GetBookingPolicyQueryError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>


export function useGetBookingPolicy<TData = Awaited<ReturnType<typeof getBookingPolicy>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookingPolicy>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBookingPolicy>>,
          TError,
          Awaited<ReturnType<typeof getBookingPolicy>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBookingPolicy<TData = Awaited<ReturnType<typeof getBookingPolicy>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookingPolicy>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBookingPolicy>>,
          TError,
          Awaited<ReturnType<typeof getBookingPolicy>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBookingPolicy<TData = Awaited<ReturnType<typeof getBookingPolicy>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookingPolicy>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBookingPolicy<TData = Awaited<ReturnType<typeof getBookingPolicy>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookingPolicy>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBookingPolicyQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const patchBookingPolicy = (
    trainWithMeModulesBookingDtosRequestsPatchBookingPolicyRequest?: BodyType<TrainWithMeModulesBookingDtosRequestsPatchBookingPolicyRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesBookingDtosResponsesBookingPolicyResponse>(
      {url: `/booking-policy`, method: 'PATCH',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesBookingDtosRequestsPatchBookingPolicyRequest, signal
    },
      options);
    }




export const getPatchBookingPolicyMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchBookingPolicy>>, TError,{data?: BodyType<TrainWithMeModulesBookingDtosRequestsPatchBookingPolicyRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patchBookingPolicy>>, TError,{data?: BodyType<TrainWithMeModulesBookingDtosRequestsPatchBookingPolicyRequest>}, TContext> => {

const mutationKey = ['patchBookingPolicy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchBookingPolicy>>, {data?: BodyType<TrainWithMeModulesBookingDtosRequestsPatchBookingPolicyRequest>}> = (props) => {
          const {data} = props ?? {};

          return  patchBookingPolicy(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchBookingPolicyMutationResult = NonNullable<Awaited<ReturnType<typeof patchBookingPolicy>>>
    export type PatchBookingPolicyMutationBody = BodyType<TrainWithMeModulesBookingDtosRequestsPatchBookingPolicyRequest> | undefined
    export type PatchBookingPolicyMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>

    export const usePatchBookingPolicy = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchBookingPolicy>>, TError,{data?: BodyType<TrainWithMeModulesBookingDtosRequestsPatchBookingPolicyRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchBookingPolicy>>,
        TError,
        {data?: BodyType<TrainWithMeModulesBookingDtosRequestsPatchBookingPolicyRequest>},
        TContext
      > => {
      return useMutation(getPatchBookingPolicyMutationOptions(options), queryClient);
    }
    export const deleteBookingPolicyCustomerCustomerIdSelfBooking = (
    customerId: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesBookingDtosResponsesSelfBookingPermissionResponse>(
      {url: `/booking-policy/customer/${customerId}/self-booking`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteBookingPolicyCustomerCustomerIdSelfBookingMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBookingPolicyCustomerCustomerIdSelfBooking>>, TError,{customerId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteBookingPolicyCustomerCustomerIdSelfBooking>>, TError,{customerId: number}, TContext> => {

const mutationKey = ['deleteBookingPolicyCustomerCustomerIdSelfBooking'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteBookingPolicyCustomerCustomerIdSelfBooking>>, {customerId: number}> = (props) => {
          const {customerId} = props ?? {};

          return  deleteBookingPolicyCustomerCustomerIdSelfBooking(customerId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteBookingPolicyCustomerCustomerIdSelfBookingMutationResult = NonNullable<Awaited<ReturnType<typeof deleteBookingPolicyCustomerCustomerIdSelfBooking>>>

    export type DeleteBookingPolicyCustomerCustomerIdSelfBookingMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>

    export const useDeleteBookingPolicyCustomerCustomerIdSelfBooking = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBookingPolicyCustomerCustomerIdSelfBooking>>, TError,{customerId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteBookingPolicyCustomerCustomerIdSelfBooking>>,
        TError,
        {customerId: number},
        TContext
      > => {
      return useMutation(getDeleteBookingPolicyCustomerCustomerIdSelfBookingMutationOptions(options), queryClient);
    }
    export const getBookingPolicyCustomerCustomerIdSelfBooking = (
    customerId: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesBookingDtosResponsesSelfBookingPermissionResponse>(
      {url: `/booking-policy/customer/${customerId}/self-booking`, method: 'GET', signal
    },
      options);
    }




export const getGetBookingPolicyCustomerCustomerIdSelfBookingQueryKey = (customerId: number,) => {
    return [
    `/booking-policy/customer/${customerId}/self-booking`
    ] as const;
    }


export const getGetBookingPolicyCustomerCustomerIdSelfBookingQueryOptions = <TData = Awaited<ReturnType<typeof getBookingPolicyCustomerCustomerIdSelfBooking>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(customerId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookingPolicyCustomerCustomerIdSelfBooking>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBookingPolicyCustomerCustomerIdSelfBookingQueryKey(customerId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBookingPolicyCustomerCustomerIdSelfBooking>>> = ({ signal }) => getBookingPolicyCustomerCustomerIdSelfBooking(customerId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: customerId !== null && customerId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBookingPolicyCustomerCustomerIdSelfBooking>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBookingPolicyCustomerCustomerIdSelfBookingQueryResult = NonNullable<Awaited<ReturnType<typeof getBookingPolicyCustomerCustomerIdSelfBooking>>>
export type GetBookingPolicyCustomerCustomerIdSelfBookingQueryError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>


export function useGetBookingPolicyCustomerCustomerIdSelfBooking<TData = Awaited<ReturnType<typeof getBookingPolicyCustomerCustomerIdSelfBooking>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 customerId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookingPolicyCustomerCustomerIdSelfBooking>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBookingPolicyCustomerCustomerIdSelfBooking>>,
          TError,
          Awaited<ReturnType<typeof getBookingPolicyCustomerCustomerIdSelfBooking>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBookingPolicyCustomerCustomerIdSelfBooking<TData = Awaited<ReturnType<typeof getBookingPolicyCustomerCustomerIdSelfBooking>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 customerId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookingPolicyCustomerCustomerIdSelfBooking>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBookingPolicyCustomerCustomerIdSelfBooking>>,
          TError,
          Awaited<ReturnType<typeof getBookingPolicyCustomerCustomerIdSelfBooking>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBookingPolicyCustomerCustomerIdSelfBooking<TData = Awaited<ReturnType<typeof getBookingPolicyCustomerCustomerIdSelfBooking>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 customerId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookingPolicyCustomerCustomerIdSelfBooking>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBookingPolicyCustomerCustomerIdSelfBooking<TData = Awaited<ReturnType<typeof getBookingPolicyCustomerCustomerIdSelfBooking>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 customerId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookingPolicyCustomerCustomerIdSelfBooking>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBookingPolicyCustomerCustomerIdSelfBookingQueryOptions(customerId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const putBookingPolicyCustomerCustomerIdSelfBooking = (
    customerId: number,
    trainWithMeModulesBookingDtosRequestsPutCustomerSelfBookingRequest?: BodyType<TrainWithMeModulesBookingDtosRequestsPutCustomerSelfBookingRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesBookingDtosResponsesSelfBookingPermissionResponse>(
      {url: `/booking-policy/customer/${customerId}/self-booking`, method: 'PUT',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesBookingDtosRequestsPutCustomerSelfBookingRequest, signal
    },
      options);
    }




export const getPutBookingPolicyCustomerCustomerIdSelfBookingMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putBookingPolicyCustomerCustomerIdSelfBooking>>, TError,{customerId: number;data?: BodyType<TrainWithMeModulesBookingDtosRequestsPutCustomerSelfBookingRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putBookingPolicyCustomerCustomerIdSelfBooking>>, TError,{customerId: number;data?: BodyType<TrainWithMeModulesBookingDtosRequestsPutCustomerSelfBookingRequest>}, TContext> => {

const mutationKey = ['putBookingPolicyCustomerCustomerIdSelfBooking'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putBookingPolicyCustomerCustomerIdSelfBooking>>, {customerId: number;data?: BodyType<TrainWithMeModulesBookingDtosRequestsPutCustomerSelfBookingRequest>}> = (props) => {
          const {customerId,data} = props ?? {};

          return  putBookingPolicyCustomerCustomerIdSelfBooking(customerId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutBookingPolicyCustomerCustomerIdSelfBookingMutationResult = NonNullable<Awaited<ReturnType<typeof putBookingPolicyCustomerCustomerIdSelfBooking>>>
    export type PutBookingPolicyCustomerCustomerIdSelfBookingMutationBody = BodyType<TrainWithMeModulesBookingDtosRequestsPutCustomerSelfBookingRequest> | undefined
    export type PutBookingPolicyCustomerCustomerIdSelfBookingMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>

    export const usePutBookingPolicyCustomerCustomerIdSelfBooking = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putBookingPolicyCustomerCustomerIdSelfBooking>>, TError,{customerId: number;data?: BodyType<TrainWithMeModulesBookingDtosRequestsPutCustomerSelfBookingRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putBookingPolicyCustomerCustomerIdSelfBooking>>,
        TError,
        {customerId: number;data?: BodyType<TrainWithMeModulesBookingDtosRequestsPutCustomerSelfBookingRequest>},
        TContext
      > => {
      return useMutation(getPutBookingPolicyCustomerCustomerIdSelfBookingMutationOptions(options), queryClient);
    }
